import { useOpenVoiceToVoice } from '#pplx/frontend/apps/ask/ask-input/ask-input-voice/hooks/useOpenVoiceToVoice.js';
import { isAskInputVoiceToVoiceEnabled } from '#pplx/frontend/apps/ask/ask-input/voice-controls/isAskInputVoiceToVoiceEnabled.js';
import { useWebVoiceAction } from '#pplx/frontend/apps/ask/multimodal/voice/launcher/useWebVoiceAction.js';
import { createVoiceModePlugin } from '#pplx/frontend/composer-sdk-plugins/voice-mode/index.js';
import { useIsMobile } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { useMemo } from 'react';
/**
 * Applies Ask eligibility to the shared voice action. Without a web voice provider,
 * the caller's override takes precedence over the default launcher.
 *
 * @returns A stable plugin until its eligibility, label, or launch callback changes.
 */
export function useAskComposerVoiceModePlugin({ disableActionButtons = false, hasQuery, isCometHome, isFollowUp, isMissionControl, isTranscribing, onVoiceClick, showStopButton, showVoice = true, }) {
    const { isMobileStyle, isMobileUserAgent } = useIsMobile();
    const openVoiceToVoice = useOpenVoiceToVoice();
    const { isActive, label, onPress } = useWebVoiceAction({
        fallback: onVoiceClick ?? openVoiceToVoice,
    });
    const isVoiceModeEnabled = !disableActionButtons &&
        !showStopButton &&
        !isTranscribing &&
        !hasQuery &&
        isAskInputVoiceToVoiceEnabled({
            showVoice,
            isMissionControl,
            isFollowUp,
            isCometHome,
            isMobileUserAgent,
            isMobileStyle,
            sidecarBuildFlag: import.meta.env.VITE_IS_SIDECAR_BUILD,
        });
    return useMemo(() => createVoiceModePlugin({
        isEnabled: isVoiceModeEnabled,
        label,
        onOpen: onPress,
        isActive,
    }), [isVoiceModeEnabled, onPress, label, isActive]);
}
//# sourceMappingURL=useAskComposerVoiceModePlugin.js.map